<template>
  <el-container class="PersonnelVehicleInformation">
    <el-card class="tabs-card">
      <el-form
        :inline="true"
        ref="formRef"
        :model="tableParams"
        class="demo-form-inline"
      >
        <h-unfold @refreshTableEmit="refreshTable()">
          <template #type>
            <h-selectcode
              :clearable="true"
              type="vehicle_brand"
              v-model="tableParams.carBrand"
              placeholder="车辆品牌"
              :style="{ width: '300px' }"
            ></h-selectcode>
          </template>
          <el-form-item label="车牌号" prop="carNum">
            <el-input
              v-model="tableParams.carNum"
              :clearable="true"
              placeholder="车牌号"
            ></el-input>
          </el-form-item>
          <el-form-item label="所有人信息" prop="prisonName">
            <el-input
              v-model="tableParams.prisonName"
              :clearable="true"
              placeholder="使用信息"
            ></el-input>
          </el-form-item>
          <el-form-item label="品牌" prop="carBrand">
            <h-selectcode
              :clearable="true"
              type="vehicle_brand"
              v-model="tableParams.carBrand"
              placeholder="车辆品牌"
            ></h-selectcode>
          </el-form-item>
          <el-form-item label="类型" prop="carType">
            <h-selectcode
              :clearable="true"
              type="carType"
              v-model="tableParams.carType"
              placeholder="车辆类型"
            ></h-selectcode>
          </el-form-item>
          <el-form-item label="车牌颜色" prop="carCardColor">
            <h-selectcode
              :clearable="true"
              type="car_card_color"
              v-model="tableParams.carCardColor"
              placeholder="车牌颜色"
            ></h-selectcode>
          </el-form-item>
          <el-form-item label="车身颜色" prop="carColor">
            <h-selectcode
              :clearable="true"
              type="vehicle_color_six"
              v-model="tableParams.carColor"
              placeholder="车身颜色"
            ></h-selectcode>
          </el-form-item>
          <el-form-item label="使用性质" prop="function">
            <h-selectcode
              type="carUse"
              :clearable="true"
              v-model="tableParams.function"
              placeholder="使用性质"
            ></h-selectcode>
          </el-form-item>
          <el-form-item>
            <h-button type="primary" @click="refreshTable">查询</h-button>
            <h-button @click="resetForm(formRef)">重置</h-button>
          </el-form-item>
        </h-unfold>
        <el-row :style="{ 'margin-top': '10px' }">
          <el-col>
            <h-button type="primary" @click="addButton">添加</h-button>
            <h-button type="danger" @click="delUser">删除</h-button>
            <!-- <h-button type="primary" @click="uploade">导入</h-button>
            <h-button type="primary" @click="exporting">导出当前页</h-button>
            <h-button type="primary" @click="exportingAll">导出全部</h-button>
            <h-button type="primary" @click="download">模板下载</h-button>
            <input type="file" v-show="false" ref="file" @change="myup" /> -->
            <el-dropdown>
              <h-button type="primary" :style="{ marginLeft: '10px' }"
                >导入导出
                <el-icon class="el-icon--right">
                  <arrow-down />
                </el-icon>
              </h-button>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item @click="uploade">导入</el-dropdown-item>
                  <el-dropdown-item @click="exporting">导出</el-dropdown-item>
                  <el-dropdown-item @click="exportingAll"
                    >导出全部</el-dropdown-item
                  >
                  <el-dropdown-item @click="download"
                    >下载模板</el-dropdown-item
                  >
                  <input type="file" v-show="false" ref="file" @change="myup" />
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </el-col>
        </el-row>
      </el-form>
      <div class="table-box">
        <h-table
          v-if="colorDict.length > 0"
          ref="tableRef"
          v-model:data="tableData"
          v-model:columns="columns"
          :method="carlist"
          :params="tableParams"
          @handleClick="handleClick"
          @select="hzTableSelect"
        >
          <template #prisonId="{ row }">
            <span v-if="row.prisonInfo">{{ row.prisonInfo.name }}</span>
          </template>
          <template #carNumber="{ row }">
            <h-car-plate
              class="plateNo"
              :colorData="colorDict"
              :type="row.carCardColor"
            >
              {{ row.carProvinceDict + row.carNumber }}
            </h-car-plate>
          </template>
        </h-table>
      </div>
    </el-card>
    <carpersonnel-add
      v-model="formVisible"
      :form="userFormData"
      :status="formStatus"
      @submit="userSubmit"
    ></carpersonnel-add>
  </el-container>
</template>
<script>
import { defineComponent, nextTick, reactive, toRefs, ref } from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import { carlist, cardelete } from "@/api/realHouse/realHouse.js";
import { uploadcar, derivecar, downloadcar } from "@/api/system/region.js";
import { ArrowDown } from "@element-plus/icons-vue";
import { getDict } from "@/api/constant";
import _ from "lodash";
export default defineComponent({
  name: "PersonnelVehicleInformation",
  components: { ArrowDown },
  props: {},
  setup(props) {
    const state = reactive({
      filterText: "",
      rootNodeKey: "",
      treeCard: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
      },
      dataSource: [],
      tableSelection: [],
      userFormData: {},
      tableParams: {
        cph: "",
        clpp: "",
        cllx: "",
        csys: "",
        syxz: "",
        sswy: "",
        jdcsyr: "",
      },
      tableData: [],
      formStatus: 1, // 1 添加  2 编辑
      formVisible: false,
      columns: [
        { type: "selection" },
        {
          label: "车牌号",
          slot: "carNumber",
        },
        {
          label: "车辆品牌",
          prop: "carBrandDict",
        },
        {
          label: "车辆类型",
          prop: "carTypeDict",
        },
        {
          label: "车身颜色",
          prop: "carColorDict",
        },
        // {
        //   label: "车身省份",
        //   prop: "carProvinceDict"
        // },
        {
          label: "使用性质",
          prop: "functionDict",
        },
        // {
        //   label: "机动车所有人",
        //   slot: "prisonId",
        // },
        // {
        //   label: "新建人",
        //   prop: "carOffice",
        // },
        // {
        //   label: "新建时间",
        //   prop: "createtime",
        // },
        {
          type: "operate",
          label: "操作",
          width: "140px",
          operates: [
            { name: "编辑", emitKey: "edit" },
            { name: "删除", emitKey: "del", type: "danger" },
          ],
        },
      ],
      colorDict: [],
    });
    const file = ref();
    const refData = toRefs(state);
    // const treeRef = ref(null);
    const tableRef = ref(null);
    const formRef = ref(null);
    // 获取数据字典
    const queryMenuType = async () => {
      const resCarColor = await getDict("car_card_color");
      nextTick(() => {
        state.colorDict = resCarColor.dict;
      });
      // console.log(data.colorDict);
    };
    queryMenuType();
    // 对组织树节点进行筛选时执行的方法
    const filterNode = (value, data, node) => {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    };
    // 当前选中节点变化时触发的事件
    const currentChange = (item, nodes) => {
      state.currentNode = item;
      state.tableParams.deptId = item.deptId;
      state.userFormData.parentId = item.deptId;
      nextTick(() => {
        tableRef.value && tableRef.value.refresh();
      });
    };
    // 点击查询按钮
    const refreshTable = () => {
      tableRef.value && tableRef.value.refresh();
    };
    // 重置表单
    const resetForm = (formEl) => {
      if (!formEl) return;
      formEl.resetFields();
    };
    // 表单提交
    const userSubmit = () => {
      tableRef.value && tableRef.value.refresh();
    };
    // 点击table操作按钮
    const handleClick = (operate, row) => {
      const { emitKey } = operate;
      if (emitKey === "edit") {
        // 编辑
        state.formStatus = 2; // 把表单设置为编辑状态
        state.userFormData = _.cloneDeep(row);
        // state.userFormData.roleIdList = row.roleList.map(item => item.roleId);
        state.formVisible = true;
        nextTick(() => {});
      } else if (emitKey === "info") {
        // 详情
        state.formStatus = 3; // 把表单设置为查看状态
        state.userFormData = _.cloneDeep(row);
        state.formVisible = true;
      } else if (emitKey === "del") {
        ElMessageBox.confirm("您确认要删除该车辆信息吗？", "删除", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(
          () => {
            deleteUserAsync([row.carId]);
          },
          () => {}
        );
      }
    };
    // 当用户手动勾选数据行的 Checkbox 时触发的事件
    const hzTableSelect = (selection) => {
      state.tableSelection = selection;
    };
    // 点击添加按钮
    const addButton = () => {
      state.formStatus = 1;
      state.formVisible = true;
    };
    const deleteUserAsync = async (ids) => {
      const res = await cardelete(ids);
      if (res.code === 0) {
        refreshTable();
        ElMessage({
          type: "success",
          message: "删除成功",
        });
      }
    };
    // 批量删除用户
    const delUser = () => {
      if (state.tableSelection.length > 0) {
        ElMessageBox.confirm("您确认要删除选择的车辆人员吗？", "删除", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(
          () => {
            console.log(state.tableSelection);
            const ids = state.tableSelection.map((item) => item.carId);
            deleteUserAsync(ids);
          },
          () => {}
        );
      } else {
        ElMessage({
          type: "warning",
          message: "请选择要删除的车辆人员",
        });
      }
    };
    // 导入
    const uploade = () => {
      file.value.click();
    };
    const myup = async (e) => {
      var file = e.target.files[0];
      // console.log(files, 123);
      const param = new FormData(); // 创建form对象
      param.append("file", file); // 通过append向form对象添加数据
      param.append("chunk", "0"); // 添加form表单中其他数据
      console.log(file.name);
      var filename = file.name;
      var excelname = filename.substring(filename.lastIndexOf("."));
      console.log(excelname);
      if (excelname != ".xls" && excelname != ".xlsx") {
        alert("请先下载模板后再上传!");
      } else {
        const result = await uploadcar(param);
        if (result.code == 0) {
          ElMessage({
            type: "success",
            message: "上传成功",
          });
          refreshTable();
        }
        console.log("result", result);
      }
    };
    // 下载模板
    const download = async () => {
      window.open(window.xlsxUrl + "车辆人员信息导入模板.xlsx");
    };
    // 导出
    const exporting = async () => {
      const res = await derivecar(tableRef.value.form);
      console.log(res);
      const fileName = `${+new Date()}.xls`;
      const blob = new Blob([res], {
        type: "c",
      });
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(link.href);
      }
    };

    // 导出全部
    const exportingAll = async () => {
      const params = {
        allowpage: true,
      };
      const res = await derivecar(params);
      console.log(res);
      const fileName = `${+new Date()}.xls`;
      const blob = new Blob([res], {
        type: "application/vnd.ms-excel;charset=utf-8",
      });
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(link.href);
      }
    };
    return {
      ...refData,
      filterNode,
      currentChange,
      addButton,
      refreshTable,
      tableRef,
      resetForm,
      delUser,
      hzTableSelect,
      handleClick,
      carlist,
      userSubmit,
      formRef,
      uploade,
      myup,
      file,
      download,
      exporting,
      exportingAll,
    };
  },
});
</script>
<style lang="scss" scoped>
.PersonnelVehicleInformation {
  .tree-card {
    height: 100%;
    width: 300px;
    .input-with-select {
      margin-bottom: 10px;
    }
    .tree-box {
      flex: 1;
      overflow: auto;
      position: relative;
      .tree-header {
        position: sticky;
        top: 0;
        z-index: 2;
        padding: 10px 0;
        background-color: var(--el-color-white);
        color: var(--el-text-color-regular);
        @include flex-row-sb-c;
        .tree-name {
          flex: 1;
          margin-right: 10px;
          padding-left: 48px;
        }
        .tree-status {
          width: 50px;
        }
      }
    }
  }
  .tabs-card {
    flex: 1;
    // margin-left: 10px;
    .tabs-tabel-box {
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }
    .table-box {
      flex: 1;
      overflow: hidden;
      .table-role {
        background-color: var(--el-color-info-lighter);
        box-sizing: border-box;
        border-color: transparent;
        border-radius: 5px;
        margin: 2px 0 2px 6px;
        text-align: center;
      }
    }
  }
  .carNumber {
    // background: red;

    line-height: 32px;
    text-align: center;
    width: 96px;
    height: 32px;
    color: #fff;
    border-radius: 5px;
    div {
      border-radius: 5px;

      height: calc(100% - 2px);
      margin: 1px;
      width: calc(100% - 2px);
    }
  }
}
</style>
